(function () {
  function getVariantId(checkbox) {
    return checkbox ? checkbox.getAttribute('data-gift-variant-id') : null;
  }

  function toggleNote(checkbox, show) {
    var content = checkbox.closest('[data-collapsible-content]');
    var noteWrapper = content ? content.querySelector('[data-gift-note-wrapper]') : null;
    if (noteWrapper) {
      noteWrapper.hidden = !show;
    }
  }

  function addGiftWrap(checkbox) {
    var block = checkbox.closest('[data-gift-wrap-block]');
    var button = block ? block.querySelector('[data-gift-wrap-submit]') : null;
    if (!button) return;

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: { button: button },
        bubbles: false,
      })
    );
  }

  function removeGiftWrap(checkbox) {
    var variantId = getVariantId(checkbox);
    if (!variantId) return;

    checkbox.disabled = true;

    fetch(window.theme.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        refreshCartItems();
      })
      .finally(function () {
        checkbox.disabled = false;
      });
  }

  function refreshCartItems() {
    document.querySelectorAll('cart-items').forEach(function (cartItems) {
      if (typeof cartItems.getCart === 'function') {
        cartItems.getCart();
      }
    });
  }

  // Two-way sync: if the customer removes the Gift Packaging line item
  // directly from the cart (not via this checkbox), un-check it. Runs after
  // every cart mutation, since theme:cart:change only reports a new count,
  // not which items remain.
  function syncGiftWrapCheckboxes() {
    var checkboxes = document.querySelectorAll('[data-gift-wrap-toggle]');
    if (!checkboxes.length) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        checkboxes.forEach(function (checkbox) {
          var variantId = getVariantId(checkbox);
          var stillInCart = cart.items.some(function (item) {
            return String(item.variant_id) === String(variantId);
          });

          if (checkbox.checked !== stillInCart) {
            checkbox.checked = stillInCart;
            toggleNote(checkbox, stillInCart);
          }
        });
      });
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-gift-wrap-toggle]');
    if (!checkbox) return;

    if (checkbox.checked) {
      toggleNote(checkbox, true);
      addGiftWrap(checkbox);
    } else {
      toggleNote(checkbox, false);
      removeGiftWrap(checkbox);
    }
  });

  document.addEventListener('theme:cart:change', syncGiftWrapCheckboxes);
})();
